var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('commission-quota-attainment-groups',{attrs:{"period":_vm.period,"ccg-lg":"5","ccg-xl":"5"},scopedSlots:_vm._u([{key:"commission-component-group",fn:function(ref){
var group = ref.group;
var item = ref.item;
return [_c('commission-quota-attainment-commission-component-group',{attrs:{"group":group,"item":item,"outlined":_vm.outlined}})]}},{key:"default",fn:function(ref){
var item = ref.item;
return [_c('commission-quota-attainment-commission-component',{attrs:{"item":item,"outlined":_vm.outlined}})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }